(() => {
  const mobileQuery = window.matchMedia('(max-width: 768px)');
  const compactQuery = window.matchMedia('(max-width: 390px)');
  const dialogSelector = '.hpf--customer-preview .hpf-dialog';

  const setImportant = (element, property, value) => {
    if (element) element.style.setProperty(property, value, 'important');
  };

  const removeProperties = (element, properties) => {
    if (!element) return;
    properties.forEach((property) => element.style.removeProperty(property));
  };

  const clearInlineLayout = (form) => {
    const targets = [
      form,
      form?.querySelector(':scope > form'),
      form?.querySelector('.hpf-product-form__row'),
      form?.querySelector('.hpf-product-form__qty'),
      form?.querySelector('.hpf-product-form__submit')
    ];

    targets.forEach((element) => element?.removeAttribute('style'));
  };

  const clearDialogLayout = (inner, media, content, form) => {
    removeProperties(inner, [
      'display',
      'grid-template-columns',
      'grid-template-rows',
      'grid-auto-columns',
      'width',
      'min-width'
    ]);
    removeProperties(media, ['grid-column', 'grid-row']);
    removeProperties(content, ['grid-column', 'grid-row', 'width', 'min-width']);
    removeProperties(form, ['grid-column', 'grid-row', 'justify-self']);
  };

  const forceDialogLayout = (inner, media, content, form) => {
    const mediaWidth = compactQuery.matches ? '82px' : '96px';

    setImportant(inner, 'display', 'grid');
    setImportant(inner, 'grid-template-columns', `${mediaWidth} minmax(0, 1fr)`);
    setImportant(inner, 'grid-template-rows', 'auto auto');
    setImportant(inner, 'grid-auto-columns', '0');
    setImportant(inner, 'width', '100%');
    setImportant(inner, 'min-width', '0');

    setImportant(media, 'grid-column', '1');
    setImportant(media, 'grid-row', '1');

    setImportant(content, 'grid-column', '2');
    setImportant(content, 'grid-row', '1');
    setImportant(content, 'width', 'auto');
    setImportant(content, 'min-width', '0');

    setImportant(form, 'grid-column', '1 / -1');
    setImportant(form, 'grid-row', '2');
    setImportant(form, 'justify-self', 'stretch');
  };

  const forceFormLayout = (form) => {
    if (!(form instanceof HTMLElement)) return;

    const nativeForm = form.querySelector(':scope > form');
    const row = form.querySelector('.hpf-product-form__row');
    const qty = form.querySelector('.hpf-product-form__qty');
    const submit = form.querySelector('.hpf-product-form__submit');
    if (!nativeForm || !row || !submit) return;

    const soldOut = submit.disabled || submit.getAttribute('aria-disabled') === 'true';
    form.classList.toggle('hpf-product-form--sold-out', soldOut);

    [form, nativeForm].forEach((element) => {
      setImportant(element, 'display', 'block');
      setImportant(element, 'width', '100%');
      setImportant(element, 'max-width', 'none');
      setImportant(element, 'min-width', '0');
      setImportant(element, 'box-sizing', 'border-box');
    });

    setImportant(row, 'display', 'flex');
    setImportant(row, 'width', '100%');
    setImportant(row, 'max-width', 'none');
    setImportant(row, 'min-width', '0');
    setImportant(row, 'box-sizing', 'border-box');
    setImportant(row, 'gap', '10px');
    setImportant(row, 'align-items', 'stretch');
    setImportant(row, 'flex-wrap', 'nowrap');
    setImportant(row, 'grid-template-columns', 'none');

    if (qty) {
      setImportant(qty, 'display', soldOut ? 'none' : 'block');
      setImportant(qty, 'flex', soldOut ? '0 0 0' : '0 0 64px');
      setImportant(qty, 'width', soldOut ? '0' : '64px');
      setImportant(qty, 'min-width', soldOut ? '0' : '64px');
      setImportant(qty, 'max-width', soldOut ? '0' : '64px');
      setImportant(qty, 'height', '46px');
      setImportant(qty, 'box-sizing', 'border-box');
    }

    setImportant(submit, 'display', 'flex');
    setImportant(submit, 'flex', '1 1 0');
    setImportant(submit, 'width', soldOut ? '100%' : 'auto');
    setImportant(submit, 'min-width', '0');
    setImportant(submit, 'max-width', 'none');
    setImportant(submit, 'height', '46px');
    setImportant(submit, 'box-sizing', 'border-box');
    setImportant(submit, 'align-items', 'center');
    setImportant(submit, 'justify-content', 'center');
    setImportant(submit, 'white-space', 'nowrap');
    setImportant(submit, 'writing-mode', 'horizontal-tb');
    setImportant(submit, 'text-orientation', 'mixed');
    setImportant(submit, 'overflow', 'hidden');
    setImportant(submit, 'grid-column', 'auto');

    if (soldOut) {
      submit.textContent = 'Sold Out';
      submit.setAttribute('aria-label', 'Sold Out');
    }
  };

  const prepareDialog = (dialog) => {
    if (!(dialog instanceof HTMLElement)) return;

    const inner = dialog.querySelector(':scope > .hpf-dialog__inner');
    const media = inner?.querySelector(':scope > .hpf-dialog__media');
    const content = inner?.querySelector(':scope > .hpf-dialog__content');
    if (!inner || !media || !content) return;

    let form = inner.querySelector(':scope > .hpf-product-form[data-hpf-mobile-sheet-form]');
    if (!form) form = content.querySelector(':scope > .hpf-product-form');
    if (!form) return;

    let placeholder = content.querySelector(':scope > [data-hpf-mobile-form-placeholder]');
    if (!placeholder) {
      placeholder = document.createElement('span');
      placeholder.hidden = true;
      placeholder.dataset.hpfMobileFormPlaceholder = 'true';
      form.before(placeholder);
    }

    form.dataset.hpfMobileSheetForm = 'true';

    if (mobileQuery.matches) {
      if (form.parentElement !== inner) inner.appendChild(form);
      forceDialogLayout(inner, media, content, form);
      forceFormLayout(form);
    } else {
      if (form.parentElement !== content) placeholder.after(form);
      clearDialogLayout(inner, media, content, form);
      clearInlineLayout(form);
    }
  };

  const scan = (scope = document) => {
    if (scope instanceof Element && scope.matches(dialogSelector)) prepareDialog(scope);
    scope.querySelectorAll?.(dialogSelector).forEach(prepareDialog);
  };

  const init = () => scan(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  mobileQuery.addEventListener?.('change', () => scan(document));
  compactQuery.addEventListener?.('change', () => scan(document));
  document.addEventListener('shopify:section:load', (event) => scan(event.target));

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) scan(node);
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
